import React from 'react';
import { TinyBodyText } from '../../../ui-toolkit';

export const TinyToolTipText: React.FC<{ message: string }> = ({ message }) => <TinyBodyText>{message}</TinyBodyText>;
